globalThis.Topbar = class Topbar {
  constructor() {
    globalThis.TOPBAR = this;
    this.div = document.createElement("div");
    this.div.id = "topbar";
    this.constructControlButtons();
    this.constructPlayerButtons();
    this.constructStateButtons();
    this.constructListeners();
    document.body.append(this.div);
  }

  constructControlButtons() {
    const div = document.createElement("div");
    this.control = {
      menu: new Icon("MENU"),
      camera: new Icon("CAMERA"),
      pen: new Icon("PEN"),
    };
    div.append(...Object.values(this.control).map((icon) => icon.div));
    this.div.append(div);
  }

  constructPlayerButtons() {
    const div = document.createElement("div");
    this.players = [];
    for (let i = 0; i < 3; i++) {
      const plr = document.createElement("div");
      plr.classList.add("player", "color" + i);
      plr.addEventListener("click", this.onPlayerClick.bind(this));
      div.append((this.players[i] = plr));
    }
    this.div.append(div);
  }

  constructStateButtons() {
    const div = document.createElement("div");
    this.state = {
      cameralock: new Icon("CAMERALOCK"),
      debug: new Icon("DEBUG"),
    };
    div.append(...Object.values(this.state).map((icon) => icon.div));
    this.div.append(div);
  }

  constructListeners() {
    this.abort = new AbortController();
    addEventListener("keydown", this.onKeydown.bind(this), this.abort);
    addEventListener("addplayer", this.onAddPlayer.bind(this), this.abort);
    addEventListener(
      "removeplayer",
      this.onRemovePlayer.bind(this),
      this.abort,
    );
    this.div.addEventListener("mousedown", globalThis.cancelbubble, this.abort);
    this.constructControlListeners();
    this.constructStateListeners();
    addEventListener("store", this.onStore.bind(this), this.abort);
  }

  constructControlListeners() {
    for (const [key, icon] of Object.entries(this.control)) {
      icon.div.addEventListener(
        "click",
        () => {
          if (!this.hasControl(key)) {
            if (key !== "menu") this.clearControl();
            this.addControl(key);
          } else this.removeControl(key);
        },
        this.abort,
      );
    }
  }

  constructStateListeners() {
    for (const [detail, icon] of Object.entries(this.state)) {
      icon.div.addEventListener(
        "click",
        () => globalThis.STORE.setProp(detail, !globalThis.STORE[detail]),
        this.abort,
      );
      this.onStore({ detail });
    }
  }

  onStore(event) {
    const key = event.detail;
    if (!Object.keys(this.state).includes(key)) return;
    const value = globalThis.STORE[key];
    if (value) this.addState(key);
    else this.removeState(key);
  }

  remove() {
    this.div.remove();
    this.abort.abort();
    delete globalThis.TOPBAR;
  }

  onKeydown(event) {
    if (event.ctrlKey || event.altKey || event.metaKey) return;
    for (let i = 0; i < globalThis.PLAYER_CONTROLS.length; i++) {
      const keys = globalThis.PLAYER_CONTROLS[i];
      if (keys.includes(event.keyCode)) return globalThis.CLIENT.addPlayer(i);
    }
    switch (event.keyCode) {
      case 192:
        this.toggleControl("menu");
        break;
      case 49:
        this.toggleControl("camera");
        break;
      case 50:
        this.toggleControl("pen");
        break;
    }
  }

  toggleControl(name) {
    if (this.hasControl(name)) this.removeControl(name);
    else {
      if (name !== "menu") this.clearControl();
      this.addControl(name);
    }
  }

  clearControl() {
    for (const control_name of Object.keys(this.control))
      this.removeControl(control_name);
  }

  addControl(name) {
    if (this.hasControl(name)) return;
    this.control[name]?.div.classList.add("active");
    document.body.classList.add(name);
    dispatchEvent(new CustomEvent("addcontrol", { detail: name }));
  }

  removeControl(name) {
    if (!this.hasControl(name)) return;
    this.control[name]?.div.classList.remove("active");
    document.body.classList.remove(name);
    dispatchEvent(new CustomEvent("removecontrol", { detail: name }));
  }

  hasControl(name) {
    return this.control[name]?.div.classList.contains("active");
  }

  addState(name) {
    this.state[name]?.div.classList.add("active");
    document.body.classList.add(name);
  }

  removeState(name) {
    this.state[name]?.div.classList.remove("active");
    document.body.classList.remove(name);
  }

  hasState(name) {
    return this.state[name]?.div.classList.contains("active");
  }

  onPlayerClick(event) {
    const uid = globalThis.STORE.profile.id;
    const index = this.players.findIndex((d) => d === event.target);
    if (globalThis.WORLD.players.get(uid + index))
      globalThis.CLIENT.removePlayer(index);
    else globalThis.CLIENT.addPlayer(index);
  }

  onAddPlayer(event) {
    const [uid, index] = event.detail;
    if (uid !== globalThis.STORE.profile.id) return;
    this.players[index].classList.add("active");
  }

  onRemovePlayer(event) {
    const [uid, index] = event.detail;
    if (uid !== globalThis.STORE.profile.id) return;
    this.players[index].classList.remove("active");
  }
};
